<template>
  <div class="step step1">
    <div class="form">
      <div class="form-title">{{ labels.contactInformation }}</div>
      <div class="form-fields contact-info">
        <div class="row col-2">
          <div class="col">
            <DropList :label="labels.title" mandatory :invalid="invalidFields.title" v-model="state.title" :data="titles"
              @change="checkValue('title')"></DropList>
          </div>
          <div class="col">

          </div>
        </div>
        <div class="row col-2">
          <div class="col">
            <TextBox :label="labels.firstName" mandatory :invalid="invalidFields.firstName" v-model="state.firstName"
              @change="checkValue('firstName')"></TextBox>
          </div>
          <div class="col">
            <TextBox :label="labels.lastName" mandatory :invalid="invalidFields.lastName" v-model="state.lastName"
              @change="checkValue('lastName')"></TextBox>
          </div>
        </div>
        <div class="row col-2">
          <div class="col">
            <TextBox :label="labels.company" mandatory :invalid="invalidFields.company" v-model="state.company"
              @change="checkValue('company')"></TextBox>
          </div>
          <div class="col">
            <TextBox :label="labels.country" mandatory :invalid="invalidFields.country" v-model="state.country"
              @change="checkValue('country')"></TextBox>
          </div>

        </div>
        <div class="row col-2">
          <div class="col">
            <TextBox :label="labels.postalCode" mandatory :invalid="invalidFields.postalCode" v-model="state.postalCode"
              @change="checkValue('postalCode')"></TextBox>
          </div>
          <div class="col">
            <TextBox :label="labels.city" mandatory :invalid="invalidFields.city" v-model="state.city"
              @change="checkValue('city')"></TextBox>
          </div>

        </div>
        <div class="row col-2">
          <div class="col">
            <TextBox :label="labels.street" :invalid="invalidFields.street" v-model="state.street" mandatory></TextBox>
          </div>

          <div class="col">
            <TextBox :label="labels.phone" :invalid="invalidFields.phone" v-model="state.phone"></TextBox>
          </div>
        </div>
        <div class="row col-2">
          <div class="col">
            <TextBox :label="labels.email" mandatory :invalid="invalidFields.email" v-model="state.email"
              @change="checkValue('email')" :validation-message="emailError"></TextBox>
          </div>
          <div class="col">
            <TextBox :label="labels.email2" :invalid="invalidFields.email2" v-model="state.email2"
              @change="checkValue('email2')" :validation-message="email2Error" :tooltip="labels.emailTooltip"></TextBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DropList, TextBox } from "clariant-vue3-forms";
import { Labels, State, Utils, Config } from "../services.js";

export default {
  name: "ContactInformation",
  components: {
    TextBox,
    DropList
  },
  data() {
    return {
      state: State,
      labels: Labels,
      emailError: Labels.emailError,
      email2Error: Labels.email2Error,
      titles: Labels.titles,
      invalidFields: {
        title: false,
        firstName: false,
        lastName: false,
        company: false,
        country: false,
        city: false,
        postalCode: false,
        street: false,
        email: false
      },
      emailCharLimit: Config.emailCharLimit
    };
  },
  mounted() { },
  methods: {
    validateStep() {
      let ret = true;


      if (!this.checkValue("title")) ret = false;
      if (!this.checkValue("firstName")) ret = false;
      if (!this.checkValue("lastName")) ret = false;
      if (!this.checkValue("company")) ret = false;
      if (!this.checkValue("country")) ret = false;
      if (!this.checkValue("city")) ret = false;
      if (!this.checkValue("postalCode")) ret = false;
      if (!this.checkValue("email")) ret = false;
      if (!this.checkValue("street")) ret = false;

      if (State.email2 && !this.checkValue("email2")) ret = false;

      if (!ret) {
        Utils.showStatusMessage(Labels.invalidFields, "yellow");
      } else {
        //additional check for emails length
        if (!this.checkEmailLengths()) {
          ret = false;
          Utils.showStatusMessage(Labels.invalidEmailLength, "yellow");
        }
      }

      return ret;
    },
    checkValue(field) {
      if (!field) return false;
      if (State[field]) {
        if (field === "email") this.invalidFields[field] = !Utils.validateSingleEmail(State[field]);
        else if (field === "email2") this.invalidFields[field] = !Utils.validateEmail(State[field]);
        else this.invalidFields[field] = false;
      }
      else this.invalidFields[field] = field !== "email2";  //we only set this to true for the mandatory fields (not email2)

      //we check the length of the email fields
      if (!this.invalidFields[field] && (field === "email" || field === "email2")) {
        if (!this.checkEmailLengths()) {
          return false;
        }
      }
      return !this.invalidFields[field];
    },
    checkEmailLengths() {
      let emailLen = (State["email"] || "").length;
      let email2Len = (State["email2"] || "").length;
      if (emailLen + email2Len > this.emailCharLimit) {
        this.emailError = Labels.invalidEmailLength;
        this.email2Error = Labels.invalidEmailLength;
        this.invalidFields.email = true;
        this.invalidFields.email2 = true;
        return false;
      } else {
        if (this.emailError === Labels.invalidEmailLength) {
          this.invalidFields.email = false;
          this.invalidFields.email2 = false;
        }
        this.emailError = Labels.emailError;
        this.email2Error = Labels.email2Error;

        return true;
      }
    }
  }
};
</script>

<style scoped>
.step1 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.contact-info {
  margin-top: 40px;
}
</style>
